import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';

import { observer } from 'mobx-react';

import type { IProps as IControlProps } from '../control';
import Control from '../control';

export interface IProps extends Omit<IControlProps, 'validationResult'> {
  errors: Record<string, boolean>;
}

const ValidatedEnityControl = observer(
  withDisplayName((props: IProps) => {
    const { field } = props;
    const { errors, ...childProps } = props;

    // Hack to get validation for nested properties
    const validationResult = useComputed(() => {
      return Object.fromEntries(Object.entries(errors).filter(([key]) => key.includes(field)));
    }, [errors, field]);

    return (
      <Control {...childProps} children={props.children} validationResult={validationResult} />
    );
  }, 'ValidatedEnityControl')
);

export default ValidatedEnityControl;
